import { render } from "./Action.vue?vue&type=template&id=f4674f96"
import script from "./Action.vue?vue&type=script&lang=js"
export * from "./Action.vue?vue&type=script&lang=js"

import exportComponent from "E:\\_____LARAGON\\laragon\\www\\finalMatilda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__